import React from "react";
import {
  Box,
  FormControl,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  FormLabel,
} from "@mui/material";
import { DexConfig } from "../types/dex";

// 预设DEX列表
const PRESET_DEX_LIST = [
  {
    name: "PancakeSwap V2",
    router: {
      address: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
      name: "PancakeSwap V2",
    },
    factory: {
      address: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
    },
  },
  // {
  //   name: 'PancakeSwap V2 Testnet',
  //   router: {
  //     address: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
  //     name: 'PancakeSwap V2 Testnet'
  //   },
  //   factory: {
  //     address: '0x6725F303b657a9451d8BA641348b6761A6CC7a17'
  //   },
  // },
  {
    name: "Four.meme",
    router: {
      address: "0x5c952063c7fc8610FFDB798152D69F0B9550762b",
      name: "Four.meme",
    },
    factory: {
      address: "0x4dd6d9b25962c5eb31a089a63e8b7fa37e36d720",
    },
  },
];

interface DexSelectorProps {
  /**
   * 当前选中的DEX配置
   */
  selectedDex: DexConfig | null;

  /**
   * DEX选择变更回调
   */
  onDexChange: (dex: DexConfig) => void;
}

/**
 * DEX选择器组件
 */
const DexSelector: React.FC<DexSelectorProps> = ({
  selectedDex,
  onDexChange,
}) => {
  /**
   * 处理DEX选择变更
   */
  const handleDexChange = (
    _event: React.MouseEvent<HTMLElement>,
    newDexName: string | null
  ) => {
    if (newDexName) {
      const selectedDexConfig = PRESET_DEX_LIST.find(
        (dex) => dex.name === newDexName
      );
      if (selectedDexConfig) {
        onDexChange({
          router: selectedDexConfig.router,
          factory: selectedDexConfig.factory,
        });
      }
    }
  };

  return (
    <FormControl fullWidth>
      <FormLabel
        id="dex-select-label"
        sx={{
          fontSize: "0.75rem",
          transform: "translate(14px, -6px) scale(0.75)",
          position: "absolute",
          top: 0,
          left: 0,
          color: "text.secondary",
          pointerEvents: "none",
          backgroundColor: "background.paper",
          padding: "0px 6px",
          zIndex: 1,
        }}
      >
        DEX
      </FormLabel>
      <Box
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "4px",
          padding: "8px",
        }}
      >
        <ToggleButtonGroup
          value={selectedDex?.router?.name || ""}
          exclusive
          onChange={handleDexChange}
          aria-labelledby="dex-select-label"
          size="small"
          sx={{ flexWrap: "wrap", width: "100%" }}
        >
          {PRESET_DEX_LIST.map((dex) => (
            <Tooltip
              key={dex.name}
              title={`Router: ${dex.router.address}`}
              arrow
            >
              <ToggleButton
                value={dex.name}
                aria-label={dex.name}
                sx={{
                  minWidth: "120px",
                  m: 0.5,
                  fontSize: "0.8rem",
                }}
              >
                {dex.name}
              </ToggleButton>
            </Tooltip>
          ))}
        </ToggleButtonGroup>
      </Box>
    </FormControl>
  );
};

export default DexSelector;
